import PBKDF2 from 'crypto-js/pbkdf2';
import AES from 'crypto-js/aes';
import Base64 from 'crypto-js/enc-base64';
import CryptoJS from 'crypto-js';
import { padNumber } from 'src/plugins/string/string';
const AESEncryptor = () => {
    /**
     * Encrypt data using AES
     * @param data data to encrypt
     * @param passphrase passphrase to encrypt data with (usually user email)
     * @returns encrypted data
     */
    function encryptData(data, passphrase) {
        const salt = CryptoJS.lib.WordArray.random(128).toString(Base64);
        const iv = CryptoJS.lib.WordArray.random(16).toString(Base64);
        // might need to alter the iterations based on device as this costs memory
        const iterations = 1000;
        // generate hash from user email
        const hash = PBKDF2(passphrase, salt, {
            keySize: 8,
            iterations: iterations,
            hasher: CryptoJS.algo.SHA512
        }).toString(Base64);
        const parsedHash = Base64.parse(hash);
        const parsedIv = Base64.parse(iv);
        const encryptedData = AES.encrypt(data, parsedHash, {
            iv: parsedIv
        });
        const encryptedCt = encryptedData.ciphertext.toString(Base64);
        const ivLen = iv.length.toString();
        const saltLen = salt.length.toString();
        const encryptedCtLen = encryptedCt.length.toString();
        const iterationsLen = `${iterations}`.length.toString();
        // set data set
        const ivStr = `01${padNumber(ivLen.length, 2)}${ivLen}${iv}`;
        const saltStr = `02${padNumber(saltLen.length, 2)}${saltLen}${salt}`;
        const ctStr = `03${padNumber(encryptedCtLen.length, 2)}${encryptedCtLen}${encryptedCt}`;
        const iterationsStr = `04${padNumber(iterationsLen.length, 2)}${iterationsLen}${iterations}`;
        return `${ivStr}${saltStr}${ctStr}${iterationsStr}`;
    }
    return {
        encryptData
    };
};
export { AESEncryptor };
